import { Col } from 'antd';
import NumericInput from 'components/NumericInput';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { createDecimalRegExp } from 'utils/patterns';

export const monedasEnum = Object.freeze({
  PESO: 1,
  SM: 3,
  UMA: 4,
});
const FormItemByMoneda = ({ moneda, mutable, allowZero }) => {
  const monedaDefault = useSelector(({ auth }) => auth.entidad?.moneda);
  const [decimal] = createDecimalRegExp(monedaDefault);

  const validateImporte = async (rule, val) => {
    const notAllowZero = typeof val === 'number' && !allowZero && val === 0;

    if ((typeof val === 'string' && !val?.length) || notAllowZero) {
      throw new Error(notAllowZero ? 'El importe no puede ser 0' : 'El campo es requerido');
    } else if (!decimal.test(val)) {
      throw new Error('Ingrese un valor decimal válido');
    }
  };

  const rules = {
    importe: [
      {
        validator: validateImporte,
      },
    ],
  };

  const getLabelByMoneda = (_moneda) => {
    switch (_moneda) {
      case monedasEnum.PESO:
        return 'Importe';
      case monedasEnum.SM:
      case monedasEnum.UMA:
        return 'Cantidad';
      default:
        return '';
    }
  };

  if (!Object.values(monedasEnum).includes(moneda)) return null;

  return (
    <Col xs={24} sm={24} md={8}>
      <NumericInput
        required
        name="importe"
        label={getLabelByMoneda(moneda)}
        rules={moneda === monedasEnum.PESO ? rules.importe : undefined}
        disabled={!mutable}
        decimal
        commas
      />
    </Col>
  );
};

FormItemByMoneda.propTypes = {
  moneda: PropTypes.oneOf(Object.values(monedasEnum)).isRequired,
  mutable: PropTypes.bool.isRequired,
  allowZero: PropTypes.bool.isRequired,
};

export default FormItemByMoneda;
